import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import { Text, Tooltip, rem } from '@mantine/core';
import styled from 'styled-components';

interface ITagPair {
	className?: string;
	title?: string;
	subtitle?: string | React.ReactNode;
	tooltipText?: string | React.ReactNode;
}

export const TagPair = styled(({ className, title, subtitle, tooltipText }: ITagPair) => {
	const SubTitleComponent = (
		<Text
			size="B6Medium"
			style={{
				color: defaultTheme.v3.colors.gray[0],
				textOverflow: 'ellipsis',
				textShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
				overflow: 'hidden',
				whiteSpace: 'nowrap',
			}}
		>
			{subtitle}
		</Text>
	);
	return (
		<div className={className}>
			{title && (
				<Text size="B6Medium" style={{ color: defaultTheme.v3.colors.gray[9] }}>
					{title}
				</Text>
			)}
			{tooltipText ? (
				<Tooltip label={tooltipText} style={{ whiteSpace: 'pre-line' }}>
					{SubTitleComponent}
				</Tooltip>
			) : (
				subtitle && SubTitleComponent
			)}
		</div>
	);
})`
	display: flex;
	flex-direction: column;
	padding: 0.5rem 0.5rem 0 0.5rem;
	min-height: ${rem(40)};
	text-overflow: ellipsis;
`;
